/* eslint-disable @typescript-eslint/no-explicit-any */
import { AbstractControl, AsyncValidatorFn, ValidatorFn } from '@angular/forms';
import { FormConverterFn } from './decorators';

export enum ColumnType {
  FIELD,
  SUBFORM,
  ARRAY,
}

export type UpdateStrategy = 'blur' | 'submit' | 'change';

export type FormValidator = ValidatorFn | ValidatorFn[] | null;
export type AsyncFormValidator = AsyncValidatorFn | AsyncValidatorFn[] | null;

export interface FieldDefinition {
  targetConstructor: any;
  propertyName: string;
  propertyType: any;
  name: string;
  type: ColumnType;
  validators?: FormValidator;
  updateOn?: UpdateStrategy;
  asyncValidator?: AsyncFormValidator;
  converter?: FormConverterFn<any>;
}

export interface FormModelDefinition {
  targetConstructor: any;
  validators?: FormValidator;
  asyncValidator?: AsyncFormValidator;
  converter?: new () => FormConverterFn<any>;
  afterMapping?: (control: AbstractControl) => void;
}
